import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RoleNameProvider } from '../providers/role-name.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';
import { RoleNameInterface } from '../data/role-name.interface';

@Injectable()
export class GetRoleNameUseCase implements UseCase<Observable<Transaction<RoleNameInterface[]>>> {
    constructor(private roleNameProvider: RoleNameProvider) {}

    bind(): Observable<Transaction<RoleNameInterface[]>> {
        return this.roleNameProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (types) => Transaction.success(cloneDeep(types)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
